import { logError, logMessage, hasLocalStorage } from 'src/utils/helpers'

const appName = process.env.REACT_APP_NAME

export function hasSessionStorage() {
  const test = 'temporary-ss-test'
  try {
    sessionStorage.setItem(test, test)
    sessionStorage.removeItem(test)
    return true
  } catch (e) {
    return false
  }
}

export default class Storage {
  static getSessionItem(key) {
    if (hasSessionStorage()) {
      return sessionStorage.getItem(`${appName}-${key}`)
    } else {
      return null
    }
  }

  static setSessionItem(key, value) {
    if (hasSessionStorage()) {
      return sessionStorage.setItem(`${appName}-${key}`, value)
    }
  }

  static removeSessionItem(key) {
    if (hasSessionStorage()) {
      return sessionStorage.removeItem(`${appName}-${key}`)
    }
  }

  static getItem(key) {
    if (hasLocalStorage()) {
      return localStorage.getItem(`${appName}-${key}`)
    } else {
      return null
    }
  }

  static setItem(key, value) {
    if (hasLocalStorage()) {
      return localStorage.setItem(`${appName}-${key}`, value)
    }
  }

  static removeItem(key) {
    if (hasLocalStorage()) {
      return localStorage.removeItem(`${appName}-${key}`)
    }
  }

  static clear() {
    if (hasLocalStorage()) {
      const preservedItems = {
        originalDocumentTitle: Storage.getItem('originalDocumentTitle'),
        hasFlashingDocumentTitle: Storage.getItem('hasFlashingDocumentTitle'),
      }

      localStorage.clear()

      // Restore preserved values
      Object.keys(preservedItems).map(item => {
        return Storage.setItem(item, preservedItems[item])
      })
    }
  }

  static clearCaches(type = 'global') {
    try {
      if (window.hasOwnProperty('caches') && window.caches) {
        if (type === 'all') {
          window.caches.delete('kiosk-documents')
          window.caches.delete('kiosk-files')
        }

        // Delete global kiosk pre cache
        // SWPrecacheWebpackPlugin adds additional strings around our cache name, so we need to find it like this
        // sw-precache is no longer used, now we use workbox precache (but we need to clear both since people still have the old one as well)
        window.caches.keys().then(cacheNames => {
          cacheNames.forEach(cacheName => {
            if (cacheName.includes('kiosk-sw-pre-cache') || cacheName.includes('cache')) {
              window.caches.delete(cacheName)
            }
          })
        })
      }
    } catch (e) {
      logError('Clear kiosk pre cache', e)
    }
  }

  static verifyStorageVersion(appVersion) {
    const localVersion = this.getItem('version')
    if (localVersion !== appVersion) {
      logMessage('New version added!')
      this.clear()
      this.setItem('version', appVersion)
    }
  }
}
